import styled from 'styled-components';

export const Container = styled.div`
    max-width: 1172px;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;

    @media (max-width: 1110px) {
        padding: 0 16px;
        width: 100%;
    }

    @media (max-width: 768px) {
        padding: 0 12px;
    }

    @media (max-width: 480px) {
        padding: 0 8px;
    }
`;
